import classNames from "classnames"

import useAutoId from "web/hooks/behaviour/useAutoId"

import Label from "./Label"

const Radio = (props) => {
  const {
    id,
    name,
    label,
    description,
    value = {},
    kind,
    onChange,
    lookup_values,
    hideLabel = false,
    disabled = false,
    flexDirection = "row",
    centerText = true,
  } = props

  const radioId = useAutoId(id)

  function handleOnChange(e) {
    onChange({ value: e.target.value, kind })
  }

  const radios = lookup_values.map((lv) => {
    const checked = value && lv.value === value.value

    const spanClassName = classNames("rounded flex-1 cursor-pointer", {
      "bg-primary-10 text-blue-900": checked && !disabled,
      "bg-gray-600 text-white": checked && disabled,
      "text-gray-600": !checked,
      "hover:bg-primary-10 hover:text-blue-900": !disabled,
      [lv.className]: lv.className,
    })

    const labelValueClassName = classNames({
      "mx-auto": centerText,
      "pl-2": lv.prefix,
    })

    const valueId = `${radioId}-${lv.value}`

    return (
      <div key={valueId} className={spanClassName}>
        <input
          id={valueId}
          className="hidden"
          type="radio"
          name={name}
          value={lv.value}
          checked={checked}
          onChange={handleOnChange}
          disabled={disabled}
          data-testid={`radio-input-${lv.value}`}
        />
        <label
          htmlFor={valueId}
          className="flex cursor-pointer px-2 py-2"
          data-testid={`radio-label-${lv.value}`}
        >
          {lv.prefix && <div className="pr-1">{lv.prefix}</div>}
          <div className={labelValueClassName}>{lv.label}</div>
        </label>
      </div>
    )
  })

  const containerClassNames = classNames("flex text-sm", {
    "flex-col space-y-1": flexDirection === "col",
    "flex-row space-x-1": flexDirection !== "col",
  })

  return (
    <>
      {!hideLabel && (
        <Label kind={kind} label={label} description={description} />
      )}
      <div className={containerClassNames}>{radios}</div>
    </>
  )
}

export default Radio
